import { shuffle } from "./shuffle";

describe("shuffle", () => {
    function arraysEqual(a1, a2) {
        return JSON.stringify(a1) == JSON.stringify(a2);
    }

    it("shuffles an array", () => {
        const arrayBefore = ["1", "2", "3", "4", "5", "6"];
        const arrayShuffled = shuffle(["1", "2", "3", "4", "5", "6"]);
        expect(arraysEqual(arrayShuffled, arrayBefore)).toBeFalsy();
    });
});
